export class CapturaEtapa {
  id?: number;
  etapaId?: number;
  tipoCaptura?: string;
  valorCaptura?: string;
  valorInsercao?: string;
  variavelSalvamentoId?: number;
  fluxoEnvioId?: number;
}
